import { axiosInstance } from "../../../../Services";
import { MMH_PRODUCTS_BASE_PATH, USE_MOCK } from "./config";
import { mockDeleteProduct } from "../mock/mockApi";

// DELETE — DELETE /internal/mmh-products/:id
export const DeleteMMHProduct = async (id) => {
  if (USE_MOCK) {
    return mockDeleteProduct(id);
  }
  return axiosInstance.delete(`${MMH_PRODUCTS_BASE_PATH}/${id}`);
};

export default DeleteMMHProduct;
